require("jquery-ui/ui/widgets/autocomplete.js");

function MaterialSupplierAutoComplete() {

    $(function () {
    });

    $("#SupplierIdSearch").autocomplete({
        minLength: 1,
        source: function (request, response) {
            $.ajax({
                url: "GetSupplier",
                type: "POST",
                dataType: "json",
                data: { searchTerm: request.term },
                success: function (data) {
                    $("#SupplierId").val('0');
                    response($.map(data, function (item) {
                        return { label: item.name, value: item.recordID };
                    }))
                }
            })
        },
        select: function (event, ui) {
            $("#SupplierId").val(ui.item.value);
            $("#SupplierIdSearch").val(ui.item.label);

            return false;
        }
    });
}


$(function () {
});

module.exports = MaterialSupplierAutoComplete;